import React, { useRef } from "react";
import "./landingStyle-jss";

const newsData = [
  {
    label: "e-learning",
    url: "/",
  },
  {
    label: "Awareness Week",
    url: "/",
  },
  {
    label: "Request For workshop",
    url: "/",
  },
  {
    label: "3-level certification scheme",
    url: "/",
  },
  {
    label: "V-labs",
    url: "/",
  },
  {
    label: "Cyber Quiz",
    url: "/",
  },
];

const NewsItem = ({ text }) => {
  const marqueeRef = useRef(null);

  const handleMouseEnter = () => {
    // Pause the marquee animation
    marqueeRef.current.style.animationPlayState = "paused";
  };

  const handleMouseLeave = () => {
    // Resume the marquee animation
    marqueeRef.current.style.animationPlayState = "running";
  };
  return (
    <div
      className="marquee"
      ref={marqueeRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="marquee-content">
        {newsData.map((item, index) => (
          <div key={index}>
            <span>
              <a href={item.url}>{item.label}</a>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsItem;
